module.exports = __webpack_public_path__ + "img/people_wk.f156b6bb.png";